import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

const FEE_GROUP_ENDPOINT = {
  CREATE_FEE_GROUP: "/fee-group",
  GET_ALL_FEE_GROUPS: "/fee-group",
  GET_FEE_GROUP_BY_ID: "/fee-group",
  UPDATE_FEE_GROUP: "/fee-group/update",
  DELETE_FEE_GROUP: "/fee-group/delete",
}

export type FEE_GROUP = {
  _id: string
  createdAt: string
  description: string
  name: string
  status: string
  session: { _id: string; title: string; startDate: string }
  system: { _id: string; name: string; description: string }
  updatedAt: string
}

export type FEE_GROUP_PAYLOAD = {
  _id?: string
  description: string
  name: string
  status: string
  session: string
  system: string
}

const createFeeGroup = async (data: FEE_GROUP_PAYLOAD): Promise<FEE_GROUP> => {
  const response = await apiClient({
    url: FEE_GROUP_ENDPOINT.CREATE_FEE_GROUP,
    method: "POST",
    data,
  })
  return response.data
}

const getAllFeeGroups = async ({
  page = 1,
  limit = 10,
  status,
  session,
  system,
  name,
  sortBy,
  sortOrder,
  searchText: search,
  branch,
}: {
  page?: number
  limit?: number
  status?: string
  session?: string
  system?: string
  name?: string
  sortBy?: string
  sortOrder?: string
  searchText?: string
  // Explicit opt-in only — every other caller of this list keeps seeing every
  // campus's groups (several screens rely on that for cross-campus
  // filtering/reporting). Pass this only where showing another campus's
  // same-named group would let someone pick the wrong one, e.g. the Add/Edit
  // Fee Type dropdown.
  branch?: string
}): Promise<{ pagination: any; data: FEE_GROUP[] }> => {
  const response = await apiClient({
    url: appendQueryParams(FEE_GROUP_ENDPOINT.GET_ALL_FEE_GROUPS, {
      page,
      limit,
      status,
      session,
      system,
      name,
      sortBy,
      sortOrder,
      searchText: search,
      branch,
    }),
    method: "GET",
  })
  return response.data
}

const updateFeeGroup = async (
  id: string,
  data: FEE_GROUP_PAYLOAD
): Promise<FEE_GROUP> => {
  const response = await apiClient({
    url: `${FEE_GROUP_ENDPOINT.UPDATE_FEE_GROUP}/${id}`,
    method: "PUT",
    data,
  })
  return response.data
}

const deleteFeeGroup = async (id: string) => {
  const response = await apiClient({
    url: `${FEE_GROUP_ENDPOINT.DELETE_FEE_GROUP}/${id}`,
    method: "DELETE",
  })
  return response.data
}

export { createFeeGroup, deleteFeeGroup, getAllFeeGroups, updateFeeGroup }
